import styled from "styled-components";

export const Title = styled.h1`
color: ${p => p.theme.colors.black};
font-size: ${p => p.theme.fontSizes.xl};
padding-bottom: ${p => p.theme.space[6]}px;
text-align: center;
`